import React, { useState } from "react";

import EmployeeTakenLeaves from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/EmployeeTakenLeaves";
import EmployeeUpcommingHolidays from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/EmployeeUpcommingHolidays";
import EmployeeTimeOffRequests from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/EmployeeTimeOffRequests";

import { NEW_ACTIVITY } from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeoffNewActivity/Enum";

import "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/EmployeeTimeOffDetails.css";
import "components/Screens/Timeoff/ManageTimeoff/ManageTimeoff.scss";

function EmployeeTimeOffDetails() {
  const [screenView, setScreenView] = useState(NEW_ACTIVITY.ALL_EMPLOYEES_REQUESTS);
  const [leaveTakenSuccessfully, setLeaveTakenSuccessfully] = useState(false);

  return (
    <div className="manage-timeoff-wrapper-admin ">
      <EmployeeTakenLeaves
        setLeaveTakenSuccessfully={setLeaveTakenSuccessfully}
        leaveTakenSuccessfully={leaveTakenSuccessfully}
      />

      {screenView === NEW_ACTIVITY.ALL_EMPLOYEES_REQUESTS && <EmployeeUpcommingHolidays portal="admin" />}
      <EmployeeTimeOffRequests
        setScreenView={setScreenView}
        screenView={screenView}
        leaveTakenSuccessfully={leaveTakenSuccessfully}
      />
    </div>
  );
}

export default EmployeeTimeOffDetails;
